import React from "react";

export default function TableOrder() {
  return <div>My Table Order</div>;
}
